export default "\n<section class=\"boxConteudo\">\n<router-outlet></router-outlet>\n</section>\n"